import React from 'react';
import { Menu } from '@tencent/spaui';
import { RPCFactory } from './../../../utils/RequestUtil';
import { NoticeNav } from './noticeNav';
import { menu } from './menu';

const ItemComponent = (props) => {
  const { className, href = 'javascript:;', onClick, label, nodeData } = props;

  return (
    <a className={className} href={href} onClick={onClick}>
      {label != '未读消息' ? (
        <span className="spaui-menu-text">{label}</span>
      ) : (
        <span className="spaui-menu-text">
          {label}
          <span className="base-label info xs">
            <span className="base-label-num">
              <div style={{ 'text-align': 'center', 'min-width': '15px' }}>
                {nodeData && nodeData.unReadNum ? nodeData.unReadNum : 0}
              </div>
            </span>
          </span>
        </span>
      )}
    </a>
  );
};

export class NoticeCenter extends React.PureComponent {
  constructor(props) {
    super(props);

    const target = menu.find((item) => location.hash.indexOf(item.href) !== -1);
    const value = target ? target.href : '#/message/index';
    const noticeStatus = target ? target.key : 'ALL';
    this.state = {
      noticeStatus,
      value,
      menuData: menu,
      unReadData: {},
    };
  }

  getUnread = () => {
    RPCFactory.noticeCenter.getCategory({ noticeStatus: 'UNREAD' }).done((res) => {
      menu[1].unReadNum = res.noticeCount;
      this.setState({ menuData: [...menu], unReadData: res });
    });
  };

  componentDidMount() {
    this.getUnread();
  }

  handleChange = (event, data) => {
    if (data.href || data.key) {
      this.setState({
        value: data.href || data.key,
        noticeStatus: data.key,
      });
    }
  };

  goBack = () => {
    window.location.hash = '/';
  };

  render() {
    const { noticeStatus, unReadData, menuData, value } = this.state;
    return (
      <div className="notice-center-whole">
        <div className="notice-sidebar">
          <div className="notice-sidebar-inner">
            <div className="notice-text">消息中心</div>
            <Menu
              fixed={false}
              toggle={false}
              value={value}
              onChange={this.handleChange}
              data={menuData}
              ItemComponent={ItemComponent}
            />
          </div>
        </div>
        <div className="notice-main">
          <NoticeNav unReadData={unReadData} noticeStatus={noticeStatus} getUnread={this.getUnread} />
        </div>
      </div>
    );
  }
}
